// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-2-right';

export const Component = () => (
  <path d='m13.435 21.348-.144.144a1.27 1.27 0 0 1-.575.144c-.67 0-1.005-.335-1.005-.958 0-.144.096-.335.239-.67l5.987-8.19-6.035-8.285c-.143-.24-.191-.431-.191-.575 0-.623.335-.958 1.005-.958.192 0 .383.048.575.144l.144.143 6.8 8.86a.946.946 0 0 1 .288.671c0 .239-.096.431-.239.67l-6.848 8.86Zm-7.71 0-.145.144a1.27 1.27 0 0 1-.575.144c-.67 0-1.005-.335-1.005-.958 0-.144.096-.335.24-.67l5.986-8.19L4.19 3.533c-.142-.24-.19-.431-.19-.575C4 2.335 4.335 2 5.005 2c.192 0 .383.048.575.144l.144.143 6.801 8.86a.946.946 0 0 1 .287.671c0 .239-.096.431-.239.67l-6.848 8.86Z' />
);

export const viewBox = '0 0 25 25';
